import React, { useEffect, useState } from "react";
import MainTemplate from "../../templates/MainTemplate";
import { Button } from "react-bootstrap";
import { Tabs, Tab, Box, Grid, Snackbar, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { Stack, Pagination, PaginationItem } from "@mui/material";
import {
  getAdmins,
  getSurveyors,
  deleteAdmin,
  deleteSurveyors,
} from "../../../api/services/services";
import AddRoleForm from "../../molecules/AddRoleForm";
import SuccessRole from "../../molecules/SuccessRole";
import MuiAlert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
// import Paper from '@mui/material/Paper';
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import "./style.css";
import trashImg from "../../../imgs/trash.png";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";

const Roles = () => {
  const [addRoleModal, setAddRoleModal] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [success, setSuccess] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [search, setSearch] = useState("");
  const [uuid, setUid] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [editLoading, setIsEditLoading] = useState(false);
  const [superAdminEmail, setSuperAdminEmail] = useState("");

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const handlePageChange = (event, newPage) => setCurrentPage(newPage);

  const handleRowsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const handleChange = (event, newValue) => {
    setCurrentPage(1);
    setValue(newValue);
  };

  const getList = () => {
    setData([]);
    setIsLoading(true);
    getAdmins(currentPage, itemsPerPage, search)
      .then((response) => {
        setIsLoading(false);
        setData(response?.data?.data?.admins);
        setSuperAdminEmail(response?.data?.data?.superAdminEmail || "");
        setTotalPages(Math.ceil(response?.data?.data?.totalRecords / itemsPerPage));
      })
      .catch((error) => {
        setIsLoading(false);
        setData([]);
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        } else if (error?.response?.data?.message) {
          setSnackbarMessage(error?.response?.data?.message);
          setOpenSnackbar(true);
        }
      });
  };

  const getAllSurveyors = () => {
    setData([]);
    setIsLoading(true);
    getSurveyors(currentPage, itemsPerPage, false, search)
      .then((response) => {
        setIsLoading(false);
        setData(response?.data?.data?.surveyers);
        setTotalPages(Math.ceil(response?.data?.data?.totalRecords / itemsPerPage));
      })
      .catch((error) => {
        setIsLoading(false);
        setData([]);
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        } else if (error?.response?.data?.message) {
          setSnackbarMessage(error?.response?.data?.message);
          setOpenSnackbar(true);
        }
      });
  };

  const convertDate = (unixTimestamp) => {
    if (!unixTimestamp) return "-";
    const date = new Date(unixTimestamp * 1000);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (value == 0) getList(); else getAllSurveyors();
  }, [currentPage, itemsPerPage, value, search]);

  const deleteAdminUser = (uuid) => {
    setDeleteLoading(true);
    deleteAdmin(uuid).then(() => { setDeleteLoading(false); getList(); }).catch((error) => {
      setDeleteLoading(false);
      if (error?.response?.data?.statusCode == 401) {
        localStorage.clear(); window.location.pathname = "/login";
      } else if (error?.response?.data?.message) {
        setSnackbarMessage(error?.response?.data?.message); setOpenSnackbar(true);
      }
    });
  };

  const deleteSurveyorUser = (uuid) => {
    setDeleteLoading(true);
    deleteSurveyors(uuid).then(() => { setDeleteLoading(false); getList(); }).catch((error) => {
      setDeleteLoading(false);
      if (error?.response?.data?.statusCode == 401) {
        localStorage.clear(); window.location.pathname = "/login";
      } else if (error?.response?.data?.message) {
        setSnackbarMessage(error?.response?.data?.message); setOpenSnackbar(true);
      }
    });
  };

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit().then(() => { setIsVerified(true); setIsEditLoading(false); }).catch(() => { setIsVerified(false); setIsEditLoading(false); });
  };

  return (
    <>
      <MainTemplate>
        <div className="roles-page-wrapper">
          <div className="page-header-container d-flex align-items-center">
            <div>
              <h1 className="page-title">Role Management</h1>
              <p className="page-subtitle">Configure system administrators and field surveyors</p>
            </div>
            <div className="ms-auto">
              <button className="btn-premium" onClick={() => setAddRoleModal(true)}>
                + Add New Role
              </button>
            </div>
          </div>

        <div className="glass-card p-4">
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              borderBottom: '1px solid rgba(0,0,0,0.05)',
              mb: 3,
              '& .MuiTabs-indicator': { backgroundColor: 'var(--primary-color)', height: 3, borderRadius: '3px 3px 0 0' },
              '& .MuiTab-root': { fontWeight: 600, fontSize: '0.85rem', color: 'var(--text-muted)', '&.Mui-selected': { color: 'var(--primary-color)' } }
            }}
          >
            <Tab label="ADMINS" />
            <Tab label="SURVEYORS" />
          </Tabs>

          {value === 0 && superAdminEmail && (
            <Box mb={3} p={2} sx={{ backgroundColor: 'rgba(var(--primary-color-rgb, 0, 123, 255), 0.05)', borderRadius: '8px', borderLeft: '4px solid var(--primary-color)' }}>
              <Typography variant="body2" sx={{ color: 'var(--text-muted)' }}>
                <strong>Super Admin:</strong> {superAdminEmail}
              </Typography>
            </Box>
          )}

          <div className="search-bar-premium mb-4">
             <SearchIcon sx={{ color: 'var(--text-light)', mr: 1 }} />
             <InputBase
                placeholder="Search by name or email..."
                fullWidth
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ fontSize: '0.9rem' }}
             />
          </div>

          <TableContainer component={Paper} elevation={0} sx={{ background: 'transparent' }}>
            <Table className="premium-table">
              <TableHead>
                <TableRow>
                  <TableCell className="table-head">S.No</TableCell>
                  <TableCell className="table-head">Name</TableCell>
                  <TableCell className="table-head">Email</TableCell>
                  <TableCell className="table-head">Created Date</TableCell>
                  <TableCell className="table-head text-center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length > 0 ? (
                  data.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{(currentPage - 1) * itemsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {row.name}
                        {value === 0 && row.email === superAdminEmail && (
                          <span style={{
                            marginLeft: '8px',
                            background: 'var(--primary-color)',
                            color: 'white',
                            fontSize: '0.65rem',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            verticalAlign: 'middle',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em'
                          }}>
                            Super Admin
                          </span>
                        )}
                      </TableCell>
                      <TableCell sx={{ color: 'var(--text-muted)' }}>{row.email}</TableCell>
                      <TableCell>{convertDate(row.createdAt)}</TableCell>
                      <TableCell className="text-center">
                        {(deleteLoading || editLoading) && row.uuid === uuid ? (
                          <CircularProgress size={20} sx={{ color: 'var(--primary-color)' }} />
                        ) : (
                          <IconButton onClick={() => { setUid(row.uuid); sendEditRequestToAdmin(); }} sx={{ color: 'var(--error)', '&:hover': { background: 'rgba(239, 68, 68, 0.05)' } }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="3 6 5 6 21 6"></polyline>
                              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                              <line x1="10" y1="11" x2="10" y2="17"></line>
                              <line x1="14" y1="11" x2="14" y2="17"></line>
                            </svg>
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center py-5">
                      {isLoading ? <CircularProgress size={30} sx={{ color: 'var(--primary-color)' }} /> : "No records found matching your criteria."}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-4 pt-3 border-top gap-3">
             <div className="d-flex align-items-center gap-2">
                <span className="small text-muted">Show</span>
                <select className="form-select form-select-sm" value={itemsPerPage} onChange={handleRowsPerPageChange} style={{ width: '80px', borderRadius: '8px' }}>
                   <option value="10">10</option>
                   <option value="25">25</option>
                   <option value="50">50</option>
                </select>
                <span className="small text-muted">entries per page</span>
             </div>
             <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                shape="rounded"
                size="small"
                renderItem={(item) => <PaginationItem {...item} sx={{ mx: 0.5, borderRadius: '8px', fontWeight: 600 }} />}
             />
          </div>
        </div>

        {addRoleModal && (
          <AddRoleForm open={addRoleModal} onClose={() => setAddRoleModal(false)}
            onSuccess={() => { setAddRoleModal(false); setSuccess(true); if (value === 1) getAllSurveyors(); else getList(); }}
          />
        )}

        <SuccessRole open={success} onClose={() => setSuccess(false)} />

        {isVerified && (
          <SuperAdminVerifationModal open={isVerified} onClose={() => setIsVerified(false)}
            onSuccess={() => { setIsVerified(false); if (value === 0) deleteAdminUser(uuid); else deleteSurveyorUser(uuid); }}
            onError={() => { setSnackbarMessage("Invalid Pin"); setOpenSnackbar(true); }}
          />
        )}

        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <MuiAlert elevation={6} variant="filled" severity={snackbarMessage?.includes("successful") ? "success" : "error"} onClose={handleCloseSnackbar} sx={{ borderRadius: '12px', fontWeight: 600 }}>
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
        </div>
      </MainTemplate>
    </>
  );
};

export default Roles;
